import { BotType, UsageType } from "@shared/types";
import {
  Platform,
  TelegramCouplingType,
} from "@shared/features/settings/types";

export const USAGE_TYPE_TO_INLINE_OBJECT_NAME: { [key in UsageType]?: string } =
  {
    [UsageType.ACTIVE_TRADE]: "active signal trade",
    [UsageType.MANUAL_TRADE]: "active manual trade",
    [UsageType.CLIENT]: "primary API slots",
    [UsageType.DCA_BOT]: "active DCA bot",
    [UsageType.GRID_BOT]: "active Grid bot",
    [UsageType.TV_BOT]: "active TradingView bot",
    [UsageType.SIGNAL_BOT]: "active Signals bot",
    [UsageType.BACKTESTING]: "monthly backtesting runs",
  };

export const USAGE_TYPE_TO_TITLE_OBJECT_NAME: { [key in UsageType]?: string } =
  {
    [UsageType.ACTIVE_TRADE]: "Active Signal Trades",
    [UsageType.MANUAL_TRADE]: "Active Manual Trades",
    [UsageType.CLIENT]: "Primary API Slots",
    [UsageType.DCA_BOT]: "Active DCA Bots",
    [UsageType.GRID_BOT]: "Active Grid Bots",
    [UsageType.TV_BOT]: "Active TradingView Bots",
    [UsageType.SIGNAL_BOT]: "Active Signals Bots",
    [UsageType.BACKTESTING]: "Monthly Backtesting Runs",
  };

export const BOT_TYPE_TO_USAGE_TYPE: Record<BotType, UsageType> = {
  [BotType.ASAP]: UsageType.DCA_BOT,
  [BotType.GRID]: UsageType.GRID_BOT,
  [BotType.TRADING_VIEW]: UsageType.TV_BOT,
  [BotType.SIGNAL]: UsageType.SIGNAL_BOT,
};

export const USAGE_TYPES = [
  UsageType.MANUAL_TRADE,
  UsageType.ACTIVE_TRADE,
  UsageType.SIGNAL_BOT,
  UsageType.GRID_BOT,
  UsageType.DCA_BOT,
  UsageType.TV_BOT,
  UsageType.BACKTESTING,
  UsageType.CLIENT,
];

export const PLATFORM_TO_DISPLAY_NAME: Record<Platform, string> = {
  [TelegramCouplingType.TELEGRAM_BOT]: "Telegram",
  [TelegramCouplingType.WEB_OR_APP]: "Website & App",
};

export const PLATFORM_TO_KEY: Record<
  Platform,
  "telegram_notifications_active" | "web_notifications_active"
> = {
  [TelegramCouplingType.TELEGRAM_BOT]: "telegram_notifications_active",
  [TelegramCouplingType.WEB_OR_APP]: "web_notifications_active",
};

export const PLATFORM_TO_ACTIVE_KEY: Record<
  Platform,
  "is_web_active" | "is_telegram_active"
> = {
  [TelegramCouplingType.TELEGRAM_BOT]: "is_telegram_active",
  [TelegramCouplingType.WEB_OR_APP]: "is_web_active",
};

export const NOTIFICATIONS_SETTINGS_COLUMN_SPANS = [9, 7, 8];
export const MOBILE_NOTIFICATIONS_SETTINGS_COLUMN_SPANS = [14, 5, 5];

export const TELEGRAM_NOTIFICATIONS_BOT_LINK =
  "https://t.me/cornix_notifications_bot";
